<ion-item lines="none" class="ion-no-padding" [style.max-width]="maxWidth">
  <ion-label *ngIf="!hideLabel" position="stacked">
    <ion-icon *ngIf="lockIndicator" slot="start" [name]="(disabled) ? 'lock-closed-outline' : 'lock-open-outline'">
    </ion-icon>
    {{ label + (required ? '*' : '')  }}
  </ion-label>
  <ion-textarea [id]="id" [(ngModel)]="value" [placeholder]="placeholder" [maxlength]="maxLength" [rows]="rows" [autoGrow]="autoGrow" 
    [disabled]="disabled" (ionBlur)="checkValidity()" [debounce]="debounce" [inputFocus]="focus" 
    [spellcheck]="spellcheck ? 'true' : 'false'"></ion-textarea>
</ion-item>
<div class="flex-spaced" *ngIf="subLabel != null || showWordCount" [style.max-width]="maxWidth != null ? maxWidth : '600px'">
  <p class="sub-label">
    {{ subLabel }}
  </p>
  <p *ngIf="showWordCount" [class.danger]="value == null || (maxLength != null && value?.length > maxLength)" class="word-count">
    {{ value?.length || 0 }} / {{ maxLength }}
  </p>
</div>
